module.exports = "query Accounts ($page: Int = 1, $limit: Int = 99999, $asc: String = \"name\", $status: String = \"active\") {\n  accounts (page: $page, limit: $limit, asc: $asc, status: $status) {\n    data {\n      id\n      name\n    }\n    current_page\n    from\n    to\n    per_page\n    total\n  }\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/AccountsWithoutEmailPermission.graphql
// module id = Apej
// module chunks = 1624